export enum TagTypeEnum {
  general = "General",
  OCR = "OCR",
  label = "Label",
  object = "Object",
  transcript = "Transcript",
  folder = "Folder",
}
